export enum MangopayBankAccountType {
  IBAN = 'IBAN',
  US = 'US',
  CA = 'CA',
  GB = 'GB',
  OTHER = 'OTHER',
}

